import { Box } from "@chakra-ui/react";
import React from "react";

import Subject from "../components/Subject";
const SubjectScreen = () => {
  return (
    <Box>
      <Subject />
    </Box>
  );
};

export default SubjectScreen;
